import { render } from "./SessionExpired.vue?vue&type=template&id=c7fcfafc&ts=true"
import script from "./SessionExpired.vue?vue&type=script&lang=ts"
export * from "./SessionExpired.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__